import { ITourSelectViewModel } from './interface';

function placeholderData(): ITourSelectViewModel {
    return {
        title: {
            text: '',
            fontFamily: 'Gill Sans',
            fontSize: '10vmin',
            fontAlignment: 'center',
            fontWeight: 500,
            color: '#000000',
            visible: true,
            opacity: 0,
        },
        backgroundColor: '#ffffff',
        backgroundImage: {
            url: '',
            mode: 'contain',
        },

        backButton: {
            backgroundColor: '#fff',
            strokeColor: '#000',
            strokeSize: '0.6vmin',
            arrowColor: '#000',
            visible: false,
        },

        onBack: () => {},

        items: [],
    };
}

export default placeholderData;
